import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import useTranslate from '../../../i18n/useTranslate'
import { Paper } from '@material-ui/core'
import { ButtonView } from '../../../control/button/button'

interface Props {
    id: number
    fullName: string
    username: string
    group: string
    usergroup: string
    statusID: number
    irb: number
    updateDate: string
    onDelete: (userID: string | number) => void
}

const Item: React.FC<Props> = ({ id, fullName, username, usergroup, onDelete }) => {
    const classes = useStyles()
    const history = useHistory()
    const translate = useTranslate()
    const onEdit = () => {
        history.push(`/officer/${id}/edit`)
    }
    return (
        <Paper variant="outlined" className={classes.item}>
            <Grid container spacing={2} alignItems="center">
                <Grid container item xs={12} sm={12} md={3} lg={2} spacing={1}>
                    <Grid item>
                        <ButtonView className={classes.btnEdit} onClick={onEdit}>
                            {translate.get('BUTTON.EDIT')}
                        </ButtonView>
                    </Grid>
                    <Grid item>
                        <ButtonView className={classes.btnDelete} onClick={() => onDelete(id)}>
                            {translate.get('BUTTON.DELETE')}
                        </ButtonView>
                    </Grid>
                </Grid>

                <Grid container item xs={12} sm={12} md={3} lg={4}>
                    <Grid item xs={12}>
                        <Typography noWrap className={classes.header}>
                            {translate.get('UM.USERGROUP.FULLNAME')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{fullName}</Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} md={4} lg={4}>
                    <Grid item xs={12}>
                        <Typography noWrap className={classes.header}>
                            {translate.get('UM.USERGROUP.USERNAME')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography noWrap>{username}</Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} sm={12} md={2} lg={2}>
                    <Grid item xs={12}>
                        <Typography noWrap className={classes.header}>
                            {translate.get('UM.USERGROUP.OFFICER.USERGROUP-LABEL')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{usergroup}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    )
}

const useStyles = makeStyles((theme) => ({
    item: {
        width: '100%',
        padding: theme.spacing(3),
        margin: theme.spacing(2, 0),
        '&:hover': {
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },
    icon: {
        marginRight: theme.spacing(1),
        width: 40,
        height: 40,
        backgroundColor: '#ece9e9',
        transition: '0.3s',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
    },
    recentTime: {
        position: 'absolute',
        top: 2,
        right: 4,
        color: 'grey',
    },

    header: {
        fontWeight: 'bold',
    },
    btnEdit: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
        height: '44px',
        marginRight: '1px',
    },
    btnDelete: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
        height: '44px',
        marginRight: '1px',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.background.default,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    multiLineEllipsis: {
        maxWidth: '100%',
        whiteSpace: 'pre-wrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
    },
}))

export default Item
